import { css, styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { H5 } from '#/components/Text/H5';
import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

import { flashBarStyleColor } from './flashBarStyleColor';

export const FlashBarContainer = styled.div<{
  $variant: keyof typeof flashBarStyleColor;
}>`
  ${({ $variant }) => {
    const flashTheme = flashBarStyleColor[$variant] || flashBarStyleColor.info;
    return css`
      --color: ${colors[flashTheme.color]};
      --bg: ${colors[flashTheme.bg]};
    `;
  }}

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: ${gutterWidth / 2 + 8}px;
  padding-block: 10px;
  background-color: var(--bg);
  color: var(--color);
`;

export const FlashBarCloseButtonHolder = styled.div`
  position: absolute;
  right: ${gutterWidth / 2}px;
  top: 50%;
  transform: translateY(-50%);
`;

export const FlashBarCloseButton = styled(Button)`
  && {
    color: var(--color);
  }
`;

export const FlashBarHeadline = styled(H5)`
  margin-block: 0;
  padding-inline: ${gutterWidth / 2}px;

  a {
    color: inherit;

    @media (hover: hover) {
      &:hover {
        color: inherit;
      }
    }
  }

  @media (min-width: ${cssBreakpoints.mdUp}) {
    padding-inline: 0;
  }
`;
